export class ImapUserMapping
{
	imapUserMappingId: number;
	imapUserMappingDate: Date;
  imapConfigurationId: number;
  userId: number;
}
